import { isEmpty } from "lodash";

export default class Constants {
  static APPOINTMENT_ITEM_NAME = 'AppointmentItem';
  static BOOK_BUSINESS_URL = 'BookBusinessUrlItem';
  static BOOKED_STATUS_NAME = 'BOOKED';
  static CHECKED_IN_STATUS_NAME = 'CHECKEDIN';
  static CONFIRMED_STATUS_NAME = 'CONFIRMED';
  static CHECKED_IN_INPUT_NAME = 'CHECKED_IN';
  static CHECKED_IN_BY_BUSINESS_INPUT_NAME = 'CHECKED_IN_BY_BUSINESS';
  static COMPLETED_STATUS_NAME = 'COMPLETED';
  static PASSED_STATUS_NAME = 'PASSED';
  static CANCELLED_STATUS_NAME = 'CANCELLED';
  static DEFAULT_TIME_SLOTS_PAGE_SIZE = 8;
  static DEFAULT_SUBLEVEL_SLOTS_PAGE_SIZE = 5;
  static AppointmentView = {
    FLAT: 1,
    GROUP_BY_TIME: 2,
    GROUP_BY_SUB_LEVEL: 3,
  };
  static NO_APPOINTMENT_MESSAGE = 'No Appointment available today';
  static SELECT_SERVICE_MESSAGE =
    'Select a Service to see available time slots';
  static BUSINESS_MESSAGE_EVENT_NAME = 'BusinessMessageReceived';
  static USER_MESSAGE_EVENT_NAME = 'UserMessageReceived';
}

export const SIGNALR_EVENTS = {
  General: 0,
  UserMessageSent: 1,
  BusinessMessageSent: 2,
  AppointmentCreated: 3,
  AppointmentUpdated: 4,
  AppointmentConfirmed: 5,
  AppointmentCheckedIn: 6,
  AppointmentCancelled: 7,
  AppointmentCommentAdded: 8,
  AppointmentCreatedByAdmin: 9,
  AppointmentUpdatedByAdmin: 10,
  AppointmentConfirmedByAdmin: 11,
  AppointmentCheckedInByAdmin: 12,
  AppointmentCancelledByAdmin: 13,
  AppointmentCommentAddedByAdmin: 14,
  AppointmentEventTriggered: 15,
  AppointmentEventTriggeredByAdmin: 16,
};

export const SIGNALR_USER_TYPE = {
  Any: 0,
  ConsumerUser: 1,
  AdminUser: 2,
};

export const STATUS = {
  ACTIVE: 'ACTIVE',
  BOOKED: 'BOOKED',
  CONFIRMED: 'CONFIRMED',
  CHECKED_IN: 'CHECKEDIN',
  COMPLETED: 'COMPLETED',
  INCOMPLETE: 'INCOMPLETE',
  MISSED: 'MISSED',
  CANCELLED: 'CANCELLED',
  PASSED: 'PASSED',
  SERVING_NOW: 'SERVING_NOW',
  CHECKED_IN_BY_BUSINESS: 'CHECKED_IN_BY_BUSINESS',
};

export const STATUS_CAMPAIGN = {
  ACTIVE: 'ACTIVE',
  INCOMPLETE: 'INCOMPLETE',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED',
};

export const SORT_PRIORITY = {
  Active: 1,
  InComplete: 2,
  Completed: 3,
  Cancelled: 4
}

export const COLLECTION = {
  APPOINTMENTS: 'appointments',
  COMMENTS: 'comments',
  CHAT: 'chat',
  RATINGS: 'ratings',
  BUSINESSES: 'businesses',
  NOTIFICATIONS: 'notifications',
  CAMPAIGNS: 'campaigns',
  ORDERS: 'orders',
};

// HTMl conversion
export const parseMarkdown = (text) => {
  // Replace multiple new lines with a single one
  text = text.replace(/\n{2,}/g, '\n\n');
  // Bold text
  let html = text.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
  // Italic text
  html = html.replace(/\*([^*]+)\*/g, '<em>$1</em>');
  // Strikethrough text
  html = html.replace(/~~(.*?)~~/g, '<del>$1</del>');
  // Underlined text
  html = html.replace(/__([^_]+)__/g, '<u>$1</u>');
  // Lists (both unordered and ordered)
  html = html.replace(/(?:^|\n)\* (.*?)(?=\n|$)/g, '<ul><li>$1</li></ul>'); // Unordered lists
  html = html.replace(/(?:^|\n)\d+\. (.*?)(?=\n|$)/g, '<ol><li>$1</li></ol>'); // Ordered lists
  // Remove any extra closing tags for lists
  html = html.replace(/<\/ul>\s*<ul>/g, '');
  html = html.replace(/<\/ol>\s*<ol>/g, '');
  // Code blocks (multiline code)
  html = html.replace(/```([\s\S]*?)```/g, '<pre><code>$1</code></pre>');
  // Inline code
  html = html.replace(/`([^`]+)`/g, '<code>$1</code>');
  // Links
  html = html.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2">$1</a>');
  // Images
  html = html.replace(/!\[([^\]]*)\]\(([^)]+)\)/g, '<img src="$2" alt="$1" />');
  // New lines (convert to <br> tags)
  html = html.replace(/\n/g, '<br/>');
  // Remove remaining Markdown characters
  html = html.replace(/(\*\*|__|\*|~~|`|\[\[|\]\]|\[|\]|!|`|\\)/g, '');
  // Ensure proper list closing tags
  html = html.replace(/<\/ul><ul>/g, '');
  html = html.replace(/<\/ol><ol>/g, '');
  // Return the cleaned and formatted HTML
  return html;
};

export function htmlToWhatsAppMarkdown(html) {
  let text = html;

  // Convert <strong> and <b> to *
  text = text.replace(/<(strong|b)>(.*?)<\/\1>/gi, '*$2*');

  // Convert <em> and <i> to _
  text = text.replace(/<(em|i)>(.*?)<\/\1>/gi, '_$2_');

  // Convert strikethrough from style or <s> or <del> to ~
  text = text.replace(/<span[^>]*style=["'][^"']*text-decoration:\s*line-through;?[^"']*["'][^>]*>(.*?)<\/span>/gi, '~$1~');
  text = text.replace(/<(s|del)>(.*?)<\/\1>/gi, '~$2~');

  // Replace &nbsp; with space
  text = text.replace(/&nbsp;/gi, ' ');

  // Replace <br> or <br /> with \n
  text = text.replace(/<br\s*\/?>/gi, '\n');

  // Strip other HTML tags
  text = text.replace(/<[^>]+>/g, '');

  // ✅ Add space around styled text if adjacent characters are letters or numbers
  text = text.replace(/([*_~]+[^*_~]+[*_~]+)(?=\S)/g, '$1 ');

  // Trim whitespace
  return text.trim();
}

// convert to html for display in UI (table/tile view)
export function whatsAppMarkdownToHtml(text) {

  let html = text;

  // Convert bold: *text* → <strong>text</strong>
  html = html?.replace(/\*(.*?)\*/g, '<strong>$1</strong>');

  // Convert italic: _text_ → <em>text</em>
  html = html?.replace(/_(.*?)_/g, '<em>$1</em>');

  // Convert strikethrough: ~text~ → <span style="text-decoration: line-through;">text</span>
  html = html?.replace(/~(.*?)~/g, '<span style="text-decoration: line-through;">$1</span>');

  // replace \n to <br/>
  html = html.replace(/\n/g, '<br/>');

  // Wrap in <p>
  html = `<p>${html}</p>`;

  return html;
}

// purpose is to remove tags and space and next lines
export const convertHtmlToPlainText = (html) => {
  return String(html)
    .replace(/(<([^>]+)>)/gi, "")     // Removes HTML tags
    .replace(/&nbsp;/gi, ' ')        //  Replace &nbsp; with space
    .replace(/<br\s*\/?>/gi, '\n') //    Replace <br> or <br /> with \n for SMS/MMS
    .replace(/\n/g, ' ')            //   Removes line breaks and replaces with a space
    .trim();                      //     Optional: Trims any leading/trailing spaces
};

// purpose is to remove only the next lines and html styles
export const convertHtmlToMobileFormattedText = (html) => {
  return String(html)
    .replace(/<br\s*\/?>/gi, '\n')     // Replace <br> FIRST
    .replace(/(<([^>]+)>)/gi, "")      // Then remove other HTML tags
    .replace(/&nbsp;/gi, ' ')          // Replace &nbsp; with space
    .trim();
};

export function removeTextBetweenColons(text) {
  return text.replace(/:[^:]+:/g, '').trim();
}

// We want 3 functionalities
// Remove spaces inside tag pairs     _*hi *_ => _*hi*_
// Remove space between nested tags

// Add space after full markdown block if needed _*hi *_friend => _*hi*_ friend
export function fixMarkdownSpacing(text) {
  return text
    // Fix *bold * and other styles
    .replace(/(\*|_|~)(\S+)\s\1(?=\S)/g, '$1$2$1 ')

    // Fix nested styles (removes space before the closing style marker)
    .replace(/(\*|_|~)(\S+)\s(\*|_|~)/g, '$1$2$3')
}

// convert html to whatsapp compatible markdown like text
// special characters: *bold*, _italic_, ~strikethrough~, monospace, and actual newline characters (\n) 
export const htmlToWhatsApp = html => {
  if (!html) return '';

  const extractFormatting = (tagName, attributes = '') => {
    const attr = attributes.toLowerCase()?.trim();
    const isBold = ['b', 'strong'].includes(tagName) || attr.includes('font-weight: bold');
    const isItalic = ['i', 'em'].includes(tagName) || attr.includes('font-style: italic');
    const isStrike = ['s', 'strike', 'del'].includes(tagName) || attr.includes('text-decoration: line-through');
    return { isBold, isItalic, isStrike };
  };

  const processNodeWithContext = (html, fullText, offset = 0) => {
    const processMatchAndState = (match, tag, attrs, content, innerOffset) => {
      const { isBold, isItalic, isStrike } = extractFormatting(tag, attrs);
      let result = processNodeWithContext(content || '', fullText, innerOffset + match.indexOf(content));

      result = result.trim(); // Trim whitespace before applying styles
      if (isStrike) result = `~${result}~`;
      if (isBold) result = `*${result}*`;
      if (isItalic) result = `_${result}_`;

      // Look ahead: if next character needs a space, add it
      const endIndex = innerOffset + match.length;
      const nextChar = fullText[endIndex] || '';
      const needsSpace =
        nextChar &&
        ![' ', '.', ',', '!', '?', '*', '_', '~', ')', ']', '}'].includes(
          nextChar,
        );

      return result + (needsSpace ? ' ' : '');
    };

    const processSpanStrike = (match, content, innerOffset) => {
      let result = `~${processNodeWithContext(content, fullText, innerOffset + match.indexOf(content))}~`;
      // Look ahead for span strikethrough
      const endIndex = innerOffset + match.length;
      const nextChar = fullText[endIndex] || '';
      const needsSpace =
        nextChar &&
        ![' ', '.', ',', '!', '?', '*', '_', '~', ')', ']', '}'].includes(
          nextChar,
        );
      return result + (needsSpace ? ' ' : '');
    };

    let processed = html.replace(/<(b|strong|i|em|s|strike|del)([^>]*)>([\s\S]*?)<\/\1>/gi, (...args) => processMatchAndState(...args, offset));
    processed = processed.replace(/<span[^>]*style="text-decoration: line-through;?"[^>]*>([\s\S]*?)<\/span>/gi, (...args) => processSpanStrike(...args, offset));
    return processed;
  };

  const cleanHtml = input => {
    return input
      .replace(/<br\s*\/?>/gi, '\n')
      .replace(/<\/p>/gi, '\n')
      .replace(/<li>/gi, '• ')
      .replace(/<\/li>/gi, '\n')
      .replace(/<hr\s*\/?>/gi, '\n----------\n')
      .replace(/<div[^>]*>/gi, '')
      .replace(/<\/div>/gi, '')
      .replace(/&nbsp;/gi, ' ')
      .replace(/&amp;/gi, '&')
      .replace(/&lt;/gi, '<')
      .replace(/&gt;/gi, '>')
      .replace(/&quot;/gi, '"')
      .replace(/&apos;/gi, "'")
      .replace(/\n{3,}/g, '\n\n')
  };

  let current = cleanHtml(html);
  let prev;
  do {
    prev = current;
    current = processNodeWithContext(prev, html); // Pass original html
  } while (prev !== current);

  const formattedText = current
    .replace(/\s+([*_~]+)\s+/g, ' $1 ')
    .replace(/([^\s])([*_~]+)(?=[^\s])/g, '$1$2')
    .replace(/([*_~]+)(?=[^\s])/g, '$1')
    .replace(/(?<!\s)([*_~]+)/g, '$1')
    .trim()
    .replace(/([*_~]+)\s+([._?!])/g, '$1$2')
    .replace(/([._?!])\s+([*_~]+)/g, '$1$2');

  return formattedText.replace(/<[^>]+>/g, '');
};

export const getAvatarName = (userInfo) => {
  if (userInfo) {

    const { firstName, lastName, email } = userInfo;
    if (isEmpty(firstName) && isEmpty(lastName))
      return String(email).substring(0, 2).toUpperCase();
    else
      return (
        String(firstName).charAt(0).toUpperCase() +
        String(lastName).charAt(0).toUpperCase()
      );
  }
};

export const Show_Row_Count = (currentPage, index, recordPerPage) => {
  return ((currentPage - 1) * Number(recordPerPage) + index + 1);
}

// Cleans pasted Google HTML: strips classes/data-attrs/comments, keeps structure, bold, links, line breaks
export const sanitizeGoogleHtml = (html) => {

  if (isEmpty(html)) return null;

  // Remove Google's leftover HTML comments like <!--TgQPHd|||[]-->
  let clean = html.replace(/<!--[\s\S]*?-->/g, '');

  const parser = new DOMParser();
  const doc = parser.parseFromString(clean, 'text/html');

  // Tags we want to keep in the final output (structure, formatting, links)
  const allowedTags = new Set(['P', 'BR', 'STRONG', 'B', 'EM', 'I', 'UL', 'OL', 'LI', 'A', 'DIV', 'SPAN', 'H1', 'H2', 'H3', 'H4']);
  const allowedAttrs = { A: ['href'] }; // allowed attributes (a tag only for now)

  // Recursively walks the DOM tree, cleaning each node
  function walk(node) {
    [...node.childNodes].forEach(child => {
      if (child.nodeType === 1) {
        const keep = allowedAttrs[child.tagName] || [];
        [...child.attributes].forEach(attr => {
          if (!keep.includes(attr.name)) child.removeAttribute(attr.name);
        });

        if (!allowedTags.has(child.tagName)) {
          while (child.firstChild) child.parentNode.insertBefore(child.firstChild, child);
          child.parentNode.removeChild(child);
        } else {
          walk(child);
        }
      }
    });
  }

  walk(doc.body);
  return doc.body.innerHTML; // Return the cleaned HTML as a string
};

export const formatTimestamp = (dateString, timeZone) => {
  if (!dateString) return '';
  const d = new Date(dateString);
  if (isNaN(d.getTime())) return 'Invalid Date';

  try {
    // Validate timezone by testing it
    new Date(new Date().toLocaleString('en-US', { timeZone }));

    // Get current time specifically in the target timezone
    const nowInTZ = new Date(new Date().toLocaleString('en-US', { timeZone }));
    // Convert target date specifically into the target timezone
    const dInTZ = new Date(d.toLocaleString('en-US', { timeZone }));

    const diffInMilliseconds = nowInTZ - dInTZ;
    const diffInMinutes = Math.floor(diffInMilliseconds / (1000 * 60));
    const diffInHours = Math.floor(diffInMinutes / 60);
    const diffInDays = Math.floor(diffInHours / 24);

    // Future dates or less than 1 minute
    if (diffInMinutes < 1) return 'Just now';

    // Minutes ago
    if (diffInMinutes < 60) return `${diffInMinutes} min${diffInMinutes > 1 ? 's' : ''} ago`;

    // Hours ago
    if (diffInHours < 24) return `${diffInHours} hour${diffInHours > 1 ? 's' : ''} ago`;

    // Days ago (up to 7 days)
    if (diffInDays <= 7) return `${diffInDays} day${diffInDays > 1 ? 's' : ''} ago`;

    // Older than a week: fallback to full date formatted to the requested timezone
    return d.toLocaleString('en-US', {
      timeZone,
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
    });
  } catch (error) {
    // Fallback to system timezone if provided timezone is invalid
    const systemTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return d.toLocaleString('en-US', {
      timeZone: systemTimeZone,
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
    });
  }
};

// Shared currency format used everywhere money is shown:
// "$" attached directly to the amount, exactly two decimals, no currency code.
export const formatCurrency = (amount, currency = 'USD') => {
  const value = Number(amount);
  const safeValue = Number.isFinite(value) ? value : 0;
  const symbol = String(currency || 'USD').toUpperCase() === 'USD' ? '$' : currency;
  return `${symbol}${safeValue.toFixed(2)}`;
};

// Unit price line, e.g. "$5.00 × 2" (no space after the currency symbol).
export const formatUnitPrice = (unitPrice, quantity, currency = 'USD') =>
  `${formatCurrency(unitPrice, currency)} × ${quantity}`;

